<template>
  <v-data-table
    :headers="headers"
    :items="produtos"
    :server-items-length="produtos.length"
    :loading="loadingProduto"
    class="mt-3"
    no-data-text="Nenhum Produto encontrado"
    loading-text="Carregando Produtos..."
    disable-pagination
    hide-default-footer
  >
    <template v-slot:header.options>
      <v-tooltip top v-if="hasAdicionavelCarrinho">
        <template v-slot:activator="{ on }">
          <v-btn icon
                 v-on="on"
                 :loading="loadingProduto"
                 @click="adicionarTodos()">
            <v-icon>mdi-cart-variant</v-icon>
          </v-btn>
        </template>
        <span>Adicionar todos os produtos ao carrinho</span>
      </v-tooltip>
    </template>
    <template v-slot:item.produto.cotacaoProduto.produto.descricao="{ item }">
      <px-indicador-compra is-produto
                           icon-class="mb-1"
                           :resposta="item.produto"/>
      <px-produto-descricao :especificacao="item.produto.cotacaoProduto.especificacaoProduto"
                            :produto="item.produto.cotacaoProduto.produto"/>
      <px-show-is-homologado v-if="isAberta(item.produto) && !item.produto.$$adicionado"
                             small
                             show-nao-homologado
                             :produto="item.produto.cotacaoProduto.produto"
                             :id-fornecedor="idFornecedor"/>
    </template>
    <template v-slot:item.produto.cotacaoProduto.quantidade="{ item }">
      {{ item.produto.cotacaoProduto.quantidade
        | number(getCurrencyFormat(casaDecimal(item))) }}
    </template>
    <template v-slot:item.produto.precoUnitario="{ item }">
      <px-matriz-preco :produto="item"
                       :moeda="moeda"
                       show-valor-convertido/>
    </template>
    <template v-slot:item.produto.total="{ item }">
      {{ item.produto.valorMoedaConvertido.total | currency('R$', casaDecimal(item)) }}
      <div class="caption" v-if="isMoedaEstrangeira">
        {{ item.produto.total
          | currency(simboloMoeda, casaDecimal(item), configuracaoFormatacaoMoeda) }}
      </div>
    </template>
    <template v-slot:item.options="{ item }">
      <div class="text-right" v-if="isAberta(item.produto) && !item.produto.$$adicionado">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn icon
                   v-on="on"
                   :loading="loadingProduto"
                   @click="adicionar(item.produto)">
              <v-icon>mdi-cart</v-icon>
            </v-btn>
          </template>
          <span>Adicionar item ao carrinho</span>
        </v-tooltip>
      </div>
    </template>
  </v-data-table>
</template>
<script>
import Vue from 'vue';
import { isEmpty } from 'lodash';
import { CasaDecimalUtils } from 'px-components';
import { SituacaoCotacao } from 'px-business-components';
import CarrinhoService from '@/modules/carrinho/carrinho-service';
import moedaMixin from '@/mixins/moeda-mixin';
import { isFornecedorHomologado, filterProdutoNaoHomologado } from '@/utils/fornecedor-produto-utils';
import PxMatrizPreco from '../components/PxMatrizPreco.vue';

export default {
  mixins: [moedaMixin],
  props: {
    produtos: {
      type: Array,
      default: () => [],
    },
    loadingProduto: {
      type: Boolean,
      default: false,
    },
    idFornecedor: {
      type: [String, Number],
      default: null,
    },
    moeda: {
      type: String,
      default: 'BRL',
    },
  },
  data() {
    return {
      todosSelecionados: false,
      headers: [
        {
          text: 'Descrição',
          sortable: true,
          value: 'produto.cotacaoProduto.produto.descricao',
        },
        {
          text: 'Quantidade',
          sortable: false,
          value: 'produto.cotacaoProduto.quantidade',
        },
        {
          text: 'Preço Unitário',
          sortable: false,
          value: 'produto.precoUnitario',
        },
        {
          text: 'Total',
          sortable: false,
          value: 'produto.total',
        },
        {
          text: null,
          sortable: false,
          value: 'options',
          align: 'right',
        },
      ],
    };
  },
  computed: {
    isAberta() {
      return item => item.cotacaoProduto.situacao === SituacaoCotacao.keys.ABERTA.key;
    },
    checkCodigo() {
      return item => item.codigo;
    },
    labelCodigo() {
      return item => `(${item.codigo})`;
    },
    getCurrencyFormat() {
      return casasDecimais => CasaDecimalUtils.getCurrencyFormat(casasDecimais);
    },
    hasAdicionavelCarrinho() {
      return this.produtos.some(p => this.isAberta(p.produto) && !p.produto.$$adicionado);
    },
    casaDecimal() {
      return item => item.produto.cotacaoProduto.produto.casasDecimais;
    },
  },
  methods: {
    isFornecedorHomologadoAoProduto(produto) {
      const { fornecedoresProduto } = produto.cotacaoProduto.produto;
      if (isEmpty(fornecedoresProduto)
      || isEmpty(fornecedoresProduto.filter(fp => fp.homologado))) {
        return true;
      }
      return isFornecedorHomologado(fornecedoresProduto, this.idFornecedor);
    },
    getProdutosNaoHomologados() {
      return this.produtos
        .map(p => p.produto.cotacaoProduto.produto)
        .filter(p => filterProdutoNaoHomologado(p, this.idFornecedor));
    },
    adicionar(item) {
      if (!this.isFornecedorHomologadoAoProduto(item)) {
        this.$toast(`Este fornecedor não é homologado para o produto: ${item.cotacaoProduto.produto.descricao}`, { color: 'error' });
        return;
      }
      this.$emit('loading-produto', true);
      CarrinhoService.adicionarProduto(item.id)
        .then(() => {
          this.$toast('Item adicionado ao carrinho', { color: 'success' });
          Vue.set(item, '$$adicionado', true);
          this.$emit('update-carrinho');
        })
        .finally(() => {
          this.$emit('loading-produto', false);
        });
    },
    isAdicionavel(produto) {
      return this.isAberta(produto.produto)
        && this.isFornecedorHomologadoAoProduto(produto.produto)
        && !produto.produto.$$adicionado;
    },
    adicionarTodos() {
      const ids = this.produtos
        .filter(p => this.isAdicionavel(p))
        .map(p => p.produto.id);
      if (ids.length === 0) {
        const produtos = this.getProdutosNaoHomologados();
        const errorMessage = produtos.length > 1 ? `Este fornecedor não é homologado para os produtos: ${produtos.map(p => p.descricao).join(', ')}` : `Este fornecedor não é homologado para o produto: ${produtos[0].descricao.trim()}`;
        this.$toast(errorMessage, { color: 'error' });
        return;
      }
      this.$emit('loading-produto', true);

      CarrinhoService.adicionarTodosProdutos(ids)
        .then(() => {
          this.produtos
            .filter(p => ids.includes(p.produto.id))
            .forEach(p => Vue.set(p.produto, '$$adicionado', true));
          this.$toast('Itens adicionados ao carrinho', { color: 'success' });
          this.$emit('update-carrinho');
        })
        .finally(() => {
          this.$emit('loading-produto', false);
        });
    },
  },
  components: {
    PxMatrizPreco,
  },
};

</script>
